import React from "react";

function ErrorPage({ message = "Unexpected Error Occured", code = 404 }) {
  return (
    <div>
      <div style={{ textAlign: "center", margin: "40px" }}>
        <h1 style={{ color: "red", margin: "40px" }}>Error:{code}</h1>
        <div style={{ fontSize: "20px" }}>{message}</div>
      </div>
    </div>
  );
}

export default ErrorPage;
